export const images = {
    logo: require("./images/icon.png"),
    icon: require("./images/logo.png"),
}